import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const BannerImagesForm = () => {
  const [image, setImage] = useState(null);
  const [position, setPosition] = useState('');
  const [url, setUrl] = useState('');
  const [amount, setAmount] = useState('');
  const [mobile, setMobile] = useState('');
  const [days,setDays]=useState('')

  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  const HeroImagesUpload = async (e) => {
    e.preventDefault();

    if (!image || !position || !url) {
      alert('All fields are required');
      return;
    }

    const formData = new FormData();
    formData.append('ImageData', image);
    formData.append('Frame', position);
    formData.append('MerchantURL', url);

    const postUrl = `https://api.bakpoket.com/api/Cat_TC_BO/add-or-update-Cat-Banner?Frame=${position}`;

    try {
      const res = await axios.post(postUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      alert('Image uploaded successfully!');
      // console.log(res)
      setImage(null);
      setUrl('');
      setPosition('');
      fileInputRef.current.value = null;
    } catch (err) {
      console.error('Upload error:', err);
      alert('Image upload failed.');
    }
  };

  const handlePayment = (e) => {
    e.preventDefault();
    if (!amount || !mobile ) {
      alert('Amount, Mobile and Position are required for payment');
      return;
    }

    navigate('/payment', {
      state: {
        amount,
        mobile,
        position:position||'CAT-TC-BO',
      },
    });
  };


  const Handelamount=()=>{
    const dates = Number(days)
    axios.get(`https://api.bakpoket.com/api/MerchantDetails/price?slotId=3&days=${dates}`)
    .then((res)=>{
      // console.log(res.data)
      setAmount(res.data.totalPrice)
    })
    .catch((err)=>console.log(err))
  }

  useEffect(()=>{
    // console.log(days.length)
    
    if(days.length >= 1){
      Handelamount()
    }
  },[days])

  return (
    <Card>
      <h2 className='text-center text-md-start pt-2 pt-md-0'>Upload Category Banner</h2>
      <form onSubmit={HeroImagesUpload}>
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={(e) => setImage(e.target.files[0])}
        />

        <select value={position} onChange={(e) => setPosition(e.target.value)}>
          <option value="">-- Select Frame --</option>
          <option value="Cat">Cat Footer</option>
          <option value="TC">TopCO Footer</option>
          <option value="BO">BesTO Footer</option>
        </select>

        <input
          type="text"
          placeholder="Enter Merchant URL"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />

        <button type="submit">Submit</button>
      </form>

      <hr />

      <h2 className='text-center text-md-start'>Payment</h2>
      <form onSubmit={handlePayment}>
        <input
          type="text"
          placeholder="Days"
          value={days}
          onChange={(e) => setDays(e.target.value)}
        />
        <input
          type="number"
          placeholder="Mobile"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
        />
        <button type="submit">Payment</button>
      </form>
    </Card>
  );
};

export default BannerImagesForm;

const Card = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
  height:auto;

  h2 {
    font-size: 22px;
    margin-bottom: 20px;
    color: #2a4157;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;

    input[type="file"],input[type="text"],input[type="number"],select  {
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 6px;
    }

    button {
      padding: 10px 15px;
      background-color: #ef4766;
      border: none;
      color: white;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 600;
      transition: background 0.3s;

      &:hover {
        background-color: #d63c5b;
      }
    }
  }

  @media (max-width: 768px) {
    max-width: 220px;
    width: 85%;
    padding: 5px;

    h2 {
      font-size: 13px;
      
    }

    button {
      font-size: 10px;
      padding: 8px 12px;
    }

    input[type="file"],input[type="text"],input[type="number"],select {
      padding: 6px;
      border: 1px solid #ccc;
      border-radius: 6px;
      font-size:11px;
    }
  }

  @media (max-width: 576px) {
    h2 {
      margin-bottom:5px;
    }

    form {
        gap: 5px;
    }

    hr{
      margin:5px;
    }
  }
`;


const TableWrapper = styled.div`
  margin-top: 20px;
  overflow-x: auto;

  h3 {
    color: #2a4157;
    font-size: 18px;
    margin-bottom: 10px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    th, td {
      border: 1px solid #ccc;
      padding: 8px 10px;
      text-align: left;
    }

    th {
      background-color: #f2f2f2;
      font-weight: bold;
    }

    tbody tr:hover {
      background-color: #f9f9f9;
    }
  }

  @media (max-width: 768px) {
    h3 {
      font-size: 13px;
      margin-bottom: 7px;
    }

    table {
    width: 100%;
    font-size: 7px;

    th, td {
      border: 1px solid #ccc;
      padding: 8px 2px;
      text-align: left;
    }

    th {
      background-color: #f2f2f2;
      font-weight: bold;
    }

    tbody tr:hover {
      background-color: #f9f9f9;
    }
  }
  }
`;